import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Zeigt den Runden-Code, kopiert per Klick einen teilbaren Link und verlinkt die Rangliste. */
export function ChallengeBadge({ code }: { code: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const shareUrl = `${window.location.origin}/join/${code}`;

  function share() {
    void navigator.clipboard?.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }

  return (
    <div className="row" style={{ gap: 8, alignItems: 'center' }}>
      <span className="eyebrow">{t('challenge.code')}</span>
      <span className="mono" data-testid="challenge-code" style={{ fontWeight: 700, letterSpacing: '0.06em' }}>{code}</span>
      <button className="btn btn-sm" onClick={share} data-testid="share-link" title={shareUrl}>
        {copied ? t('challenge.linkCopied') : t('challenge.share')}
      </button>
      <Link className="btn btn-ghost btn-sm" to={`/challenge/${code}`}>{t('challenge.viewLeaderboard')}</Link>
    </div>
  );
}
